"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.headingComponents = exports.headingVariants = void 0;

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var mapHeadingProps = {
  "h1": {
    "variant": "h1"
  },
  "h2": {
    "variant": "h2"
  },
  "h3": {
    "variant": "h3"
  },
  "h3-bold": {
    "variant": "h3",
    "className": "MuiTypography-bold"
  },
  "h4": {
    "variant": "h4"
  },
  "h5": {
    "variant": "h5"
  },
  "h5-bold": {
    "variant": "h5",
    "className": "MuiTypography-bold"
  }
};
var headingVariants = Object.keys(mapHeadingProps);
exports.headingVariants = headingVariants;
var headingComponents = ["h1", "h2", "h3", "h4", "h5", "div", "p", "span"];
exports.headingComponents = headingComponents;

var Heading = function Heading(_ref) {
  var component = _ref.component,
      variant = _ref.variant,
      color = _ref.color,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "" : _ref$title;
  return /*#__PURE__*/_react.default.createElement(_Typography.default, _extends({}, mapHeadingProps[variant], {
    component: component,
    color: color
  }), title);
};

Heading.propTypes = {
  /** The key of the SystemIcon component */
  title: _propTypes.default.string,

  /** The html wrapper element h1,h2,h3 etc */
  component: _propTypes.default.oneOf(headingComponents),

  /** The variants */
  variant: _propTypes.default.oneOf(headingVariants)
};
var _default = Heading;
exports.default = _default;